import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthStateService } from '../../features/auth/data/auth-state.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authState = inject(AuthStateService);
  const session = authState.session();

  if (session && req.url.startsWith(environment.apiUrl)) {
    return next(
      req.clone({
        setHeaders: { Authorization: `Bearer ${session.accessToken}` },
      }),
    );
  }

  return next(req);
};
